<div *transloco="let t; prefix: 'property-listing'" class="flex-1 flex flex-col">
  <!--    <div class="w-full bg-gray-100">-->
  <!--        <div class="container flex flex-col md:flex-row justify-between py-7">-->
  <!--            <h2 class="h2 text-black">{{listingDetails.basicInfo?.address?.streetNumber &&-->
  <!--                listingDetails.basicInfo?.address?.streetName ? listingDetails.basicInfo?.address?.streetNumber + ' '-->
  <!--                + listingDetails.basicInfo?.address?.streetName + ' street' : ''}}</h2>-->
  <!--            <div class="flex gap-4">-->
  <!--                <button class="btn-secondary"><i class="icon-eye mr-1"></i>{{t('buttons.previewListing')}}</button>-->
  <!--                <button (click)="onSubmitForReview()" #sendForReviewButton class="btn-primary"-->
  <!--                    [disabled]="!sendForReviewButtonEnabled">{{t('buttons.submitForReview')}}</button>-->
  <!--            </div>-->
  <!--        </div>-->
  <!--    </div>-->
  <section class="rfs:pb-24 flex-1">
    <div class="container md:flex pt-10 lg:gap-[84px]">
      <div class="flex-1 max-w-[332px]">
        <aside class="sticky z-50 top-24 lg:w-[300px]">
          <nav
            class="lg:mb-8 lg:relative fixed z-50 bottom-0 right-0 left-0 lg:bg-transparent bg-white lg:p-0 p-4 lg:rounded-0 rounded-t-[16px]">
            <div class="lg:hidden block pb-4 mb-4 border-b border-gray-200">
              <div class="flex flex-row justify-between mb-1">
                <span class="text-gray-700 text-sm">Επιλογή ενότητας</span>
                <button (click)="handleDrawer()">
                  <i [ngClass]="{'icon-chevron-down': !showDrawer, 'icon-chevron-up': showDrawer}"
                    class="text-primary-600"></i>
                </button>
              </div>
              <div class="text-black font-semibold">{{ t(currentStepLabel()) }}</div>
            </div>
            <div [ngClass]="{'block' : showDrawer, 'lg:block hidden' : !showDrawer}">
              <div (click)="onNextTab(propertyListingTab.BasicInfo)"
                [ngClass]="activeTab === propertyListingTab.BasicInfo ? 'bg-white border-primary-700 rounded-r-md lg:rounded-l-none rounded-l-md text-primary-700 font-semibold' : 'hover:text-success hover:border-success'"
                class="py-4 px-4 lg:px-6 lg:border-l-2 border-l-0 lg:hover:bg-white hover:bg-gray-50 flex justify-between items-center transition-colors">
                <button type="button">{{ t('tabs.basicInformation') }}</button>
                <i [ngClass]="tabsComplete.basicInfo ? 'icon-check text-success' : ''"
                  class="text-lg flex justify-between items-center"></i>
              </div>
              <div (click)="onNextTab(propertyListingTab.Features)"
                [ngClass]="activeTab === propertyListingTab.Features ? 'bg-white border-primary-700 rounded-r-md lg:rounded-l-none rounded-l-md text-primary-700 font-semibold' : 'hover:text-success hover:border-success'"
                class="py-4 px-4 lg:px-6 lg:border-l-2 border-l-0 lg:hover:bg-white hover:bg-gray-50 flex justify-between items-center transition-colors">
                <button type="button">{{ t('tabs.roomsAndFeatures') }}</button>
                <i [ngClass]="tabsComplete.features ? 'icon-check text-success' : ''"
                  class="text-lg flex justify-between items-center"></i>
              </div>
              <div (click)="onNextTab(propertyListingTab.Construction)"
                [ngClass]="activeTab === propertyListingTab.Construction ? 'bg-white border-primary-700 rounded-r-md lg:rounded-l-none rounded-l-md text-primary-700 font-semibold' : 'hover:text-success hover:border-success'"
                class="py-4 px-4 lg:px-6 lg:border-l-2 border-l-0 lg:hover:bg-white hover:bg-gray-50 flex justify-between items-center transition-colors">
                <button type="button">{{ t('tabs.heatingAndConstruction') }}</button>
                <i [ngClass]="tabsComplete.construction ? 'icon-check text-success' : ''"
                  class="text-lg flex justify-between items-center"></i>
              </div>
              <div (click)="onNextTab(propertyListingTab.Surroundings)"
                [ngClass]="activeTab === propertyListingTab.Surroundings ? 'bg-white border-primary-700 rounded-r-md lg:rounded-l-none rounded-l-md text-primary-700 font-semibold' : 'hover:text-success hover:border-success'"
                class="py-4 px-4 lg:px-6 lg:border-l-2 border-l-0 lg:hover:bg-white hover:bg-gray-50 flex justify-between items-center transition-colors">
                <button type="button">{{ t('tabs.settingAndSurroundings') }}</button>
                <i [ngClass]="tabsComplete.surroundings ? 'icon-check text-success' : ''"
                  class="text-lg flex justify-between items-center"></i>
              </div>
              <div (click)="onNextTab(propertyListingTab.Ownership)"
                [ngClass]="activeTab === propertyListingTab.Ownership ? 'bg-white border-primary-700 rounded-r-md lg:rounded-l-none rounded-l-md text-primary-700 font-semibold' : 'hover:text-success hover:border-success'"
                class="py-4 px-4 lg:px-6 lg:border-l-2 border-l-0 lg:hover:bg-white hover:bg-gray-50 flex justify-between items-center transition-colors">
                <button type="button">{{ t('tabs.ownership') }}</button>
                <i [ngClass]="tabsComplete.ownership ? 'icon-check text-success' : ''"
                  class="text-lg flex justify-between items-center"></i>
              </div>
              <div (click)="onNextTab(propertyListingTab.Photos)"
                [ngClass]="activeTab === propertyListingTab.Photos ? 'bg-white border-primary-700 rounded-r-md lg:rounded-l-none rounded-l-md text-primary-700 font-semibold text-primary-700 font-semibord' : 'hover:text-success hover:border-success'"
                class="py-4 px-4 lg:px-6 lg:border-l-2 border-l-0 lg:hover:bg-white hover:bg-gray-50 flex justify-between items-center transition-colors">
                <button type="button">{{ t('tabs.photos') }}</button>
                <i [ngClass]="tabsComplete.photos ? 'icon-check text-success' : ''"
                  class="text-lg flex justify-between items-center"></i>
              </div>
            </div>
            <app-navigation class="block lg:hidden"></app-navigation>
          </nav>
          <app-experts-callback [modalComponent]="'GeneralCallbackModal'"></app-experts-callback>
        </aside>
      </div>
      <ng-container *ngIf="listingForm" [ngSwitch]="activeTab">
        <app-basic-information (onNextTab)="onNextTab($event)" *ngSwitchCase="propertyListingTab.BasicInfo"
          [advisor]="listingDetails.advisor" [basicInfoFormGroup]="listingForm.controls.basicInfo"
          class="w-full"></app-basic-information>
        <app-content (onNextTab)="onNextTab($event)" *ngSwitchCase="propertyListingTab.Content"
          [advisor]="listingDetails.advisor" [contentFormGroup]="listingForm.controls.content"
          [propertyBasicInfo]="listingDetails.basicInfo"></app-content>
        <app-features (onNextTab)="onNextTab($event)" *ngSwitchCase="propertyListingTab.Features"
          [advisor]="listingDetails.advisor" [featuresFormGroup]="listingForm.controls.features">
        </app-features>
        <app-construction (onNextTab)="onNextTab($event)" *ngSwitchCase="propertyListingTab.Construction"
          [advisor]="listingDetails.advisor" [constructionFormGroup]="listingForm.controls.construction">
        </app-construction>
        <app-surroundings (onNextTab)="onNextTab($event)" *ngSwitchCase="propertyListingTab.Surroundings"
          [advisor]="listingDetails.advisor"
          [surroundingsFormGroup]="listingForm.controls.surroundings"></app-surroundings>
        <app-ownership (onNextTab)="onNextTab($event)" *ngSwitchCase="propertyListingTab.Ownership"
          [advisor]="listingDetails.advisor" [ownershipFormGroup]="listingForm.controls.ownership"></app-ownership>
        <app-photos 
            [selectedCoverImage]="this.selectedCoverPhoto" 
            [selectedSecondaryImages]="this.selectedSecondaryImages"
            (onCoverSelection)="getCoverPhoto($event)" 
            (onSecondaryImageSelection)="this.getSecondaryPhotos($event)"
            (isComplete)="setPhotosProggress($event)" 
            *ngSwitchCase="propertyListingTab.Photos"
          [propertyId]="listingDetails.propertyId"/>
      </ng-container>
    </div>
  </section>
  <app-navigation  [isLastStep]="activeTab == PropertyListingTabI.Photos"
    [redirectLink]="'/listing/'+propertyCode+'/complete'" (goToNext)="handleNext()" (goToPrevious)="handlePrev()"
    (skipTo)="handleSkip()" [hasPrevious]="true" [hasSkip]="true" class="lg:block hidden"></app-navigation>
</div>